import BaseController from '../BaseController';
import Controller, { OnClear, OnClick, OnMount, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, SearchPatientDisplacementAliases } from '../../codegen';
import { ClickEvent, MountEvent, ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ApplicationRoute } from '../../constants/routes'
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { AutocompleteAPI, BarcodeAPI, BarcodeData, FilterAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import BarcodeService from '../../services/barcode-service';
import { Inject } from '@odinjs/odin';
import { Value } from '@philips-internal/oswald-ui-core';
import { Endpoint } from '../../constants/endpoints';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Patient } from 'src/interfaces/exam-collect/patiente-data-props';

@Controller({ component: SearchPatientDisplacementAliases.LAYOUT_SEARCH_PATIENT_DISPLAY, fragment: FragmentNames.SEARCH_PATIENT_DISPLACEMENT })
class SearchPatientDisplacementController extends BaseController {

  @Inject(SearchPatientDisplacementAliases.FILTER_PATIENTS)
  private readonly filterPatients!: FilterAPI;

  @Inject(SearchPatientDisplacementAliases.AUTOCOMPLETE_DEPARTMENTS)
  private readonly autoCompletDepartments!: AutocompleteAPI;

  @Inject(SearchPatientDisplacementAliases.PANEL_MODAL)
  private readonly panelLoaderApi!: PanelAPI;

  @Inject(SearchPatientDisplacementAliases.BARCODE_COMPONENT)
  private readonly barcodeComponentApi!: BarcodeAPI;

  @OnMount({ target: SearchPatientDisplacementAliases.LAYOUT_SEARCH_PATIENT_DISPLAY })
  onMountLayout(): void {
    const param = {module: 'patientDisplacement'};
    HttpService.get(Endpoint.GENERATE_FUNCTION_LOG, param);
  }

  redirectToInformationBar(cdPaciente: string, nrAtendimento: string): void {
    const route = ApplicationRoute.PATIENT_DISPLACEMENT_PATIENT_INFORMATION;
    try {
      this.panelLoaderApi.setVisible(false);
      applicationContext.redirect(route, {
        encounterId: nrAtendimento,
        patientId: cdPaciente,
      });
    } catch (err) {
      this.barcodeComponentApi.setOpen(true);
      this.panelLoaderApi.setVisible(false);
    }
  }

  getPatientAndRedirect(nrAtendimento: string): void {
    const queryParams = `?nrAtendimento=${nrAtendimento}&page=0&limit=12`;
    const route = `${Endpoint.GET_PATIENT_LIST}${queryParams}`;

    HttpService.get(route).then(resp => {
      const body = resp.body as Patient[];
      const cdPaciente = body[0].cdPessoaFisica;
      this.redirectToInformationBar(cdPaciente, nrAtendimento);
    });
  }

  @OnClear({ target: SearchPatientDisplacementAliases.FILTER_PATIENTS })
  onFilterClear(): void {
    this.filterPatients.clear();
    this.autoCompletDepartments.setValue({} as Record<string, Value>)
  }

  @OnMount(SearchPatientDisplacementAliases.BARCODE_COMPONENT)
  handleMountBarcode(event: MountEvent): void {
    const barcodeApi = event.target as BarcodeAPI
    barcodeApi.setDefaultReadType(BarcodeService.getDefaultMethodOfReadingBarcode())
  }

  @OnReadSuccess({ target: SearchPatientDisplacementAliases.BARCODE_COMPONENT })
  onReadSucesstBarCode(event: ReadEvent<BarcodeData>): void {
    const barcode = event.target as BarcodeAPI;
    const queryParams = {
      limit: 12,
      nrAtendimento: event.item.value.trim(),
      page: 0,
      readingMode: event.item.type,
    }
    barcode.setEnabled(false);
    this.panelLoaderApi.setVisible(true);

    HttpService.get(Endpoint.GET_PATIENT_LIST, queryParams).then(resp => {
      const body = resp.body as Patient[];
      barcode.setEnabled(true);
      if (body.length === 0) {
        this.panelLoaderApi.setVisible(false);
        barcode.setOpen(true);
      } else {
        barcode.close();
        this.getPatientAndRedirect(queryParams.nrAtendimento);
      }
    }).catch(() => {
      barcode.setEnabled(true);
      barcode.setOpen(true);
      this.panelLoaderApi.setVisible(false);
    })
  }

  @OnClick({ target: SearchPatientDisplacementAliases.PATIENT_FETCH_DECK })
  onCardClick(event: ClickEvent): void {
    const { cdPessoaFisica: cdPaciente, nrAtendimento } = event.value;

    const route = ApplicationRoute.PATIENT_DISPLACEMENT_PATIENT_INFORMATION;

    applicationContext.redirect(route, {
      encounterId: String(nrAtendimento),
      patientId: cdPaciente,
    });
  }
}

export default SearchPatientDisplacementController;
